// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-5a3d6c39]{display:flex;margin-top:20px;padding:30px;width:100%;background-color:#fff;border-radius:3px}", ""]);
// Exports
module.exports = exports;
